/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ShadowMCPInventoryUserSource = {
  observedUseCount: number;
  source: string;
};

/** @internal */
export const ShadowMCPInventoryUserSource$inboundSchema: z.ZodMiniType<
  ShadowMCPInventoryUserSource,
  unknown
> = z.pipe(
  z.object({
    observed_use_count: z.int(),
    source: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "observed_use_count": "observedUseCount",
    });
  }),
);

export function shadowMCPInventoryUserSourceFromJSON(
  jsonString: string,
): SafeParseResult<ShadowMCPInventoryUserSource, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ShadowMCPInventoryUserSource$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ShadowMCPInventoryUserSource' from JSON`,
  );
}
